import React from 'react';

class DisplayEditValue extends React.PureComponent {
  static toFixedString(value) {
    return Number(value)
      .toFixed(1)
      .toString();
  }

  constructor(props) {
    super(props);

    this.state = {
      value: DisplayEditValue.toFixedString(this.props.value),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { value } = this.state;

    if (nextProps.value !== value) {
      this.set(nextProps.value);
    }
  }

  set(value) {
    const newValue = DisplayEditValue.toFixedString(value);
    this.setState({ value: newValue });
  }

  render() {
    const { hideValue } = this.props;
    const { value } = this.state;

    if (hideValue) {
      return null;
    }

    return (
      <div
        key={value}
        className="advanced-editor__display-edit-value position-absolute">
        {value}
      </div>
    );
  }
}

export default DisplayEditValue;
